// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"178":"07d8fd0a","853":"509386ce"}[chunkId] + ".css";
};